import React, { useState, forwardRef, useImperativeHandle } from 'react';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements
} from '@stripe/react-stripe-js';
import "./Step4.css";
import isPostalCode from 'validator/lib/isPostalCode';
import { Input, message, Select } from 'antd';
import { getNames } from "country-list";
import { postcodeValidatorExistsForCountry, postcodeValidator } from 'postcode-validator';
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

const { Option } = Select;

const StripePaymentForm = forwardRef((
  {
    validate,
    bookingDetails, 
    onLoadError,
    onSubmit, 
    onBack,
    formInfo,
    cardholderDifferent,
    setCardholderDifferent,
    cardholderName,
    setCardholderName,
    postalCode,
    setPostalCode,
    postalCodeError,
    setPostalCodeError,
    handleInputChange,
    handlePaymentClick
  }, 
  ref
) => {
    const stripe = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [countryName, setCountryName] = useState("India");
    const [postalCodeheck, setPostalCodecheck] = useState("");
    const [isValid, setIsValid] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState('United Kingdom (UK)'); // default
    const specialPostcodes = ['ASCN 1ZZ', 'STHL 1ZZ', 'TDCU 1ZZ', 'BBND 1ZZ', 'BIQQ 1ZZ', 'FIQQ 1ZZ', 'GX11 1AA', 'PCRN 1ZZ', 'SIQQ 1ZZ', 'TKCA 1ZZ'];
    const [cardErrors, setCardErrors] = useState({
      cardNumber: '',
      cardExpiry: '',
      cardCvc: '',
      postalCode: '',
      cardholderName: ''
    });

    // Add this to your StripePaymentForm component
    // const validatePostalCode = (code) => {
    //   if (!code) {
    //     return 'Postal code is required';
    //   }
      
    //   // Basic UK postal code pattern validation
    //   const ukPostcodePattern = /^[A-Za-z]{1,2}[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}$/i;
    //   if (!ukPostcodePattern.test(code)) {
    //     return 'Please enter a valid UK postal code';
    //   }
      
    //   return '';
    // };

    // const validatePostalCode = (code) => {
    //   if (!code) return 'Postal code is required';
    //   if (!isPostalCode(code?.trim(), 'GB')) return 'Please enter a valid UK postal code';
    //   return '';
    // };
    // const validatePostalCode = (code) => {
    //   if (!code) return 'Postal code is required';

    //   const trimmedCode = code.trim().toUpperCase();

    //   if (
    //     !isPostalCode(trimmedCode, 'GB') &&
    //     !specialPostcodes.includes(trimmedCode)
    //   ) {
    //     return 'Please enter a valid UK postal code';
    //   }

    //   return '';
    // };

        const validatePostalCode = (code, country) => {
          // const ukPostcodeRegex = /^([A-Z]{1,2}[0-9][0-9A-Z]? ?[0-9][A-Z]{2})$/i;
          const ukPostcodeRegex = /^([A-Z]{1,2}[0-9][0-9A-Z]? ?[0-9][A-Z]{2})$/i;
      if (!code) return 'Postal code is required';
      
      const trimmedCode = code.trim().toUpperCase();
      countries.registerLocale(enLocale);

      const trimmedName =country||selectedCountry?.trim();
      const clean = trimmedName?.replace(/\s*\(.*?\)\s*/g, "")?.trim();
      const countryCode = countries?.getAlpha2Code(clean, "en");
      
      if (postalCodeheck ==undefined || countryCode==undefined) {
        return
      }

        countries.registerLocale(enLocale);
        // const countryCode = countries?.getAlpha2Code("India", "en");
         if (!postcodeValidatorExistsForCountry(countryCode)) {
          return null; // or skip validation
        }
        const result = postcodeValidator(code, countryCode);
          // setIsValid(result);
          if (result === false) {
            setCardErrors({
              ...cardErrors,
              postalCode: `Please enter a valid ${country}  postal code`,
            })
            return `Please enter a valid ${country}  postal code`;
          }
      
      // Special handling for UK special postcodes
      if (country === 'UK' && specialPostcodes.includes(trimmedCode)) {
        return '';
      }
      
      // Validate based on country
      switch(country) {
        case 'UK':
          if (!isPostalCode(trimmedCode, 'GB') || !ukPostcodeRegex.test(trimmedCode)) {
            return `Please enter a valid ${country} postal code`;
          }
          break;
          
        case 'US':
          if (!isPostalCode(trimmedCode, 'US')) {
            return `Please enter a valid ${country} postal code`;
          }
          break;
          
        case 'CA':
          if (!isPostalCode(trimmedCode, 'CA')) {
            return `Please enter a valid ${country} postal code`;
          }
          break;
          
        default:
          // For other countries, just check if it's not empty
          if (!trimmedCode) {
            return 'Postal code is required';
          }
      }
      
      return '';
    };
    const handleCountryChange = (value) => {
      setSelectedCountry(value);
      handleInputChange({
        target: { name: "country", value },
      });
      setCountryName(value)
      // Clear postal code error when country changes
      setCardErrors(prev => ({
        ...prev,
        // postalCode: ''
        postalCode: validatePostalCode(postalCode, value)
      }));
    };

    const validateFields = () => {
      let isValid = true;
      const newErrors = {
        cardNumber: '',
        cardExpiry: '',
        cardCvc: '',
        postalCode: validatePostalCode(postalCode, selectedCountry),
        cardholderName: ''
      };

      // if (!validate()) {
      //   return
      // }
      const responce=validate()
      // Validate postal code
      if (!postalCode) {
        newErrors.postalCode = 'Postal code is required';
        isValid = false;
      }

      // Validate cardholder name if different
      if (cardholderDifferent && !cardholderName.trim()) {
        newErrors.cardholderName = 'Cardholder name is required';
        isValid = false;
      }

      // Check if Stripe elements are complete
      const cardNumberElement = elements.getElement(CardNumberElement);
      const cardExpiryElement = elements.getElement(CardExpiryElement);
      const cardCvcElement = elements.getElement(CardCvcElement);

      if (!cardNumberElement?._complete) {
        newErrors.cardNumber = 'Card number is required';
        isValid = false;
      }

      if (!cardExpiryElement?._complete) {
        newErrors.cardExpiry = 'Expiry date is required';
        isValid = false;
      }

      if (!cardCvcElement?._complete) {
        newErrors.cardCvc = 'CVC is required';
        isValid = false;
      }

      setCardErrors(newErrors);
      return isValid && responce;
    };


  
    const handleSubmit = async () => {
      // e.preventDefault();

      
      if (!stripe || !elements) {
        return;
      }

       // Validate all fields first
      if (!validateFields()) {
        return;
      }
  
      // if (!postalCode) {
      //   setPostalCodeError("Postal Code is required");
      //   return message.error('Postal Code is required');
      // }
  
      setLoading(true);
  
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardNumberElement),
        billing_details: {
          name: cardholderDifferent ? cardholderName : `${formInfo.firstName} ${formInfo.lastName}`,
          address: {
            postal_code: postalCode
          }
        }
      });
  
      if (error) {
        onLoadError(error);
        console.log('[createPaymentMethod error]', error);
        message.error(error.message);
        setLoading(false);
        return;
      }
  
      onSubmit(paymentMethod.id);
      setLoading(false);
    };


        // Add onChange handlers to track element completion
    const handleCardNumberChange = (event) => {
      setCardErrors(prev => ({
        ...prev,
        cardNumber: event.error?.message || ''
      }));
    };

    const handleCardExpiryChange = (event) => {
      setCardErrors(prev => ({
        ...prev,
        cardExpiry: event.error?.message || ''
      }));
    };

    const handleCardCvcChange = (event) => {
      setCardErrors(prev => ({
        ...prev,
        cardCvc: event.error?.message || ''
      }));
    };
  
  // Expose the handlePayment function to parent component
  useImperativeHandle(ref, () => ({
    handleSubmit
  }));
  
  const countriesName = getNames().sort();
  countriesName[0]="United Kingdom (UK)";

  return (
    < >
    <div>
                  {/* {formData.paymentMethod === "cardsss" && ( */}
            {(
              <>
                <h4  style={{background:"rgba(0, 131, 133, 0.25)" , color:"rgba(0, 131, 133)", padding:"8px ",fontWeight:"400",fontSize:"20px"}}  className="textLeft">Payment information:</h4>

                <div className='payment-container'>
                  
                {/* <div style={{display:"flex",justifyContent:"center",flexDirection:"column",alignItems:"center"}}> */}

                <div style={{textAlign:"left",fontSize:"18px",
                  // fontFamily:"Lato",
                  fontWeight:"400",color:"#4A4A4A",marginBottom:"10px"}}>Card information</div>
              <div className="">

                  {/* <input
                  type="text"
                  value={cardNumber}
                  onChange={handleCardInput}
                  placeholder="1234 5678 9012 3456"
                  className="form-input "
                  autoComplete="off"
                /> */}
                    <div className="stripe-input-container" style={{
                       
                    }}>
                        <CardNumberElement className=" stripe-input"
                          onChange={handleCardNumberChange}
                          options={{
                            style: {
                              base: {
                                fontSize: '16px',
                                color: '#008385',           // Change input text color
                                '::placeholder': {
                                  color: '#008385'          // Change placeholder color
                                }
                              },
                              invalid: {
                                color: 'red',               // Optional: red for invalid input
                              }
                            },
                             disableLink: true
                          }}   
                         />

                    {cardErrors.cardNumber && (
                      <div style={{ color: 'red', marginTop: '-10px', marginBottom: '10px', textAlign: 'left',fontSize: '14px' }}>
                        {cardErrors.cardNumber}
                      </div>
                    )}
                    </div>
                
                    <div
                    className="card-inputs"
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '2rem' ,// optional spacing between elements
                        color : "#008385"
                    }}
                    >
                    <div style={{ flex: 1 }}>
                        <CardExpiryElement
                        className=" stripe-input"
                        // options={{ style: { base: { fontSize: '16px' } } }}
                         onChange={handleCardExpiryChange}
                        options={{
                          style: {
                            base: {
                              fontSize: '16px',
                              color: '#008385',           // Change input text color
                              '::placeholder': {
                                color: '#008385'          // Change placeholder color
                              }
                            },
                            invalid: {
                              color: 'red',               // Optional: red for invalid input
                            }
                          }
                        }}
                        />
                          {cardErrors.cardExpiry && (
                  <div style={{ color: 'red', marginTop: '-10px', marginBottom: '10px', textAlign: 'left',fontSize: '14px'  }}>
                    {cardErrors.cardExpiry}
                  </div>
                )}
                    </div>
                    
                    <div style={{ flex: 1 }}>
                        <CardCvcElement
                        className=" stripe-input"
                        onChange={handleCardCvcChange}
                        options={{
                          style: {
                            base: {
                              fontSize: '16px',
                              color: '#008385',           // Change input text color
                              '::placeholder': {
                                color: '#008385'          // Change placeholder color
                              }
                            },
                            invalid: {
                              color: 'red',               // Optional: red for invalid input
                            }
                          }
                        }}
                        />
                        {cardErrors.cardCvc && (
                  <div style={{ color: 'red', marginTop: '-10px', marginBottom: '10px', textAlign: 'left',fontSize: '14px'  }}>
                    {cardErrors.cardCvc}
                  </div>
                )}
                    </div>
                    </div>

               </div>
                
                <div style={{textAlign:"left",fontSize:"18px",
                  // fontFamily:"Lato",
                  fontWeight:"400",color:"#4A4A4A",marginBottom:"10px"}}>Cardholder name</div>
                 <div className="form-checkbox">
                 <label className='checkbox-container'>
                  <div>
                        <input
                          type="checkbox"
                          name="differentCardholder"
                          checked={cardholderDifferent}
                          height={"8"}
                          autoComplete='differentCardholdernew'
                          width={"8"}
                          style={{height:"6px ", width:"6px ", fontSize:"14px", outline:"none !important", }}
                          onChange={() =>
                            setCardholderDifferent(!cardholderDifferent)
                          }
                        /> 
                  
                  </div>


                            Cardholder is different from the patient
                          </label>
                </div>


                {cardholderDifferent && (
                  <>
                          <div style={{ maxWidth: "100%" }}>
                            <Input
                              name="cardName"
                              placeholder="Cardholder Name"
                              autoComplete='cardNamenew'
                              value={cardholderName}
                              onChange={(e) =>
                                setCardholderName(e.target.value)
                              }
                              // suffix={<span style={{ fontSize: 12, color: '#888' }}>e.g. SW1A 1AA</span>}
                              className="cardholderInput"
                              // style={{
                              //   border: cardErrors.postalCode ? '1px solid #ff4d4f' : 
                              //     postalCode ? '1px solid #52c41a' : '1px solid #666'
                              // }}
                            />
                          </div>
                                                          {cardErrors.cardholderName && (
                  <div style={{ color: 'red', marginTop: '-10px', marginBottom: '10px', textAlign: 'left',fontSize: '14px'  }}>
                    {cardErrors.cardholderName}
                  </div>
                )}                   
                  </>


                        )}
                
               
                <div style={{textAlign:"left",fontSize:"18px",
                  // fontFamily:"Lato",
                  fontWeight:"400",color:"#4A4A4A",marginBottom:"10px"}}>Country/ region</div>

                <div
                          className="form-row"
                          style={{
                            // maxWidth:"400px",
                            padding: "0px",
                            margin: "0px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px" // spacing between fields
                          }}
                        >
                          {/* <select>
      {countries.map((country, index) => (
        <option key={index} value={country}>
          {country}
        </option>
      ))}
    </select> */}
                          <Select
                            name="country"
                            // onChange={(value) =>
                            //   handleInputChange({
                            //     target: { name: "country", value },
                            //   })
                            // }
                            onChange={handleCountryChange}

                            className="form-input countryDropdown"
                            defaultValue="United Kingdom (UK)"
                            bordered={false}
                            style={{
                              maxWidth:"100%",
                              padding: "0 10px",
                              border: "0px",
                              width: "100%",
                              height: "30px",
                              textAlign: "left",
                              color : "#008385"
                            }}
                          >
                             {countriesName.map((country, index) => (
                                <Option value={country} style={{ color: '#008385' }}>{country}</Option>
                            ))}
                            {/* <Option value="United Kingdom">
                              United Kingdom
                            </Option> */}
                              {/* <Option value="UK" style={{ color: '#008385' }} >United Kingdom</Option>
                              <Option value="US" style={{ color: '#008385' }}>United States</Option>
                              <Option value="CA" style={{ color: '#008385' }}>Canada</Option>
                              <Option value="Other">Other</Option> */}
                          </Select>
                          <Input
                            type="text"
                            id="postalCode"
                            name="postalCode"
                            placeholder="Postal code"
                            // autoComplete='postalCodenew'
                            autoComplete="postal-code"
                            value={postalCode}
                            style={{
                                height:"30px",
                                maxWidth:"100%",
                                outlineColor:"none",
                                border:"none"
                            }}
                            // onChange={(e) => {
                            //   setPostalCode(e.target.value);
                            //   setPostalCodeError("");
                            // }}
                            // onChange={(e) => {
                            //   setPostalCode(e.target.value);
                            //   // setCardErrors(prev => ({ ...prev, postalCode: '' }));
                            //       setCardErrors(prev => ({
                            //       ...prev,
                            //       postalCode: validatePostalCode(e.target.value)
                            //     }));
                            // }}


                            onChange={(e) => {
                              setPostalCode(e.target.value);
                              setPostalCodecheck(e.target.value);
                              setCardErrors(prev => ({
                                ...prev,
                                postalCode: validatePostalCode(e.target.value, selectedCountry)
                              }));
                            }}
                            className="form-input postal-code"
                          />
                        </div>
                        {/* {postalCodeError && (
                          <div style={{ color: "red" }}>{postalCodeError}</div>
                        )} */}

                         {cardErrors.postalCode && (
              <div style={{ color: 'red', marginTop: '-10px', marginBottom: '10px', textAlign: 'left',fontSize: '14px' }}>{cardErrors.postalCode}</div>
            )}
                
                </div>

              </>
            )}
    </div>
    <style jsx>

      {
        `
          .stripe-input, .form-textarea {
            height:auto;
            max-width: "100%";
            padding: 10px 12px;
            border: 1px solid #dddddd00;
            border-radius: 4px;
            font-size: 14px;
            margin-bottom: 15px;
            border-radius: 20px;
            background-color: #F0FAFA;
            color: #008385 !important;
          }
            .postal-code:focus, input[name=cardName] {
          color : #008385;

        }
          .postal-code,  input[name=cardName]{
          color : #008385;
          }
        .countryDropdown  .ant-select-selector {
  color: #008385 !important;
}
        
        `
      }
    </style>
    </>
  )
})

export default StripePaymentForm
